import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RenderMessage: React.FC = () => {
  const [errorTitle, setErrorTitle] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const navigate = useNavigate();

  useEffect(() => {
    // Extract query parameters from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const title = urlParams.get('errorTitle') || '';
    const message = urlParams.get('errorMessage') || '';
    setErrorTitle(title);
    setErrorMessage(message);

  }, []);

  return (

    <div className="inner-wrapper">
      <div className="inner-container" style={{ paddingTop: "3em", textAlign: "center" }}>
        <div className="row">
          <div className="col-md-12">
            <div>
              <h1 className="heading" id="errorTitle">{errorTitle}</h1>
            </div>
          </div>
        </div>
        <div className="single-image row absolute-important"></div>
        <div className="content row">
          <div className="col-md-12">
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <p id="errorMessage">{errorMessage}</p>
              <button
                type="submit"
                id="relogin"
                className="btn btn-submit col-sm-4"
                value="Relogin"
                name="regButton"
                onClick={() => {
                  navigate("/")
                }}
              >
                Relogin
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RenderMessage; 